import ReactPaginate from "react-paginate";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import Item from 'components/Center/Item';
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";

function Table({centers = [], getCenters, deleteCenter, totalPages, setPage, page, isSearched, setIsSearched, itemsPerPage, setItemsPerPage, resetSearch, totalCenters }){
 let myAbilities = HelpAbility();
 const {search, option, state} = isSearched;

 const handlePageClick = (data) => {
  state ? getCenters({page: data.selected + 1, [option]: search}) : getCenters({page: data.selected + 1}) ;
 };

 const resetDepartaments = async () => {
    resetSearch();
    setPage(1);
    getCenters({});
 };

 const onItemsPerPageChange = (e) => {
    const newItemsPerPage = e.target.value;
    setItemsPerPage(newItemsPerPage);
    state ? getCenters({page: 1, limit: newItemsPerPage, [option]: search}) : getCenters({page: 1, limit: newItemsPerPage});
 }

 return (
  <div className="mt-4">
   <div className="row mb-2">
    <div className="col d-flex align-items-end">
     <h6>Centros/Agentes registrados</h6>
    </div>
    <div className="col d-flex justify-content-end"> 
     <div className="d-flex flex-row gap-3">
      <div className="col d-flex flex-row align-items-center gap-2">
          <label htmlFor="items-by-page" className="form-label mb-0">Mostrar: </label>
          <select 
            onChange={onItemsPerPageChange} 
            className="form-select form-select-sm" 
            aria-label="Default select example" 
            name="items-by-page" 
            style={{width: '70px'}} 
            value={itemsPerPage}
          >
          {
            ITEMS_BY_PAGE_OPTIONS.map((value, index, arr) => {
              if(totalCenters <= arr?.[index - 1]) return null;
              return (
                <option 
                  value={value} 
                  key={'item-by-page-option-' + value}
                >
                  {value}
                </option>
              )
            })
          }            
          </select>
      </div>
      <button type="submit" className="btn btn-primary" onClick={resetDepartaments} disabled={!state}>Limpiar búsqueda</button>
     </div>
    </div>
   </div>
   <div className="table-responsive rounded-3" style={{border: '1px solid black'}}>
    <table className="table">
     <thead>
      <tr>
          <th scope="col" className="text-center">#</th>
          <th scope="col" className="text-center">Código Centro</th>
          <th scope="col" className="text-center">Nombre</th>
          <th scope="col" className="text-center">Horario de Atención</th>
          <th scope="col" className="text-center">Dirección</th>
          <th scope="col" className="text-center">Código Logístico</th>
          <th scope="col" className="text-center">Código Almacén</th>
          <th scope="col" className="text-center">Centro/Agente</th>
          <th scope="col" className="text-center">Recoger En Punto</th>
          {myAbilities.hasAny([C.A.DEPARTAMENT.UPDATE, C.A.DEPARTAMENT.DELETE]) && 
          <th scope="col" className="text-center">Acción</th>}
      </tr>
     </thead>
     <tbody>
     {
        centers.length ? 
        centers.map((center, i) => <Item 
            key={center._id}  
            i={i} 
            center={center} 
            deleteCenter={deleteCenter}
        />) 
        :
        <tr>
            <td colSpan="5">Sin datos</td>
        </tr>
     }
     </tbody>
    </table>
   </div>
   <div>
       <ReactPaginate
           previousLabel={"Anterior"}
           nextLabel={"Siguiente"}
           breakLabel={"..."}
           pageCount={totalPages}
           //Cuantas paginas quieres mostrar despues de los 3 ...
           marginPagesDisplayed={1}
           //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
           pageRangeDisplayed={2}
           forcePage={page - 1}
           onPageChange={handlePageClick}
           containerClassName={"pagination justify-content-center mt-3"}
           pageClassName={"page-item"}
           pageLinkClassName={"page-link"}
           previousClassName={"page-item"}
           previousLinkClassName={"page-link"}
           nextClassName={"page-item"}
           nextLinkClassName={"page-link"}
           breakClassName={"page-item"}
           breakLinkClassName={"page-link"}
           activeClassName={"active"}
       />
   </div>
 </div>
 )
}

export default Table
